import { FC, useMemo } from 'react';
import { GenericField } from '../models';
import { AssignEditor } from './AssignEditor';

export const FieldRenderer: FC<GenericField> = ({ field }) => {
  const FieldEditor = useMemo(() => AssignEditor[field.typeKey] ?? AssignEditor.default, [field.typeKey]);

  return <FieldEditor field={field} />;
};
